module.exports = __webpack_public_path__ + "media/images/icons/filled/file-add-3d15676b3a9cacd0bef1f5bc8b5f814a.svg";